export const timelineTokens = {
  timeline: {
    vertical: {
      eventContent: {
        padding: '0 0 0 1.5rem'
      }
    }
  }
};

export type TimelineTokens = typeof timelineTokens;
